import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { cn } from "@/lib/utils";

/**
 * M27c — react-day-picker v9 restyled with our Tailwind tokens; no stylesheet import, the
 * classNames map below is the entire skin. Range mode is the only way we use it today.
 */
export function Calendar({ className, ...props }: React.ComponentProps<typeof DayPicker>) {
  return (
    <DayPicker
      className={cn("select-none text-sm", className)}
      components={{
        Chevron: ({ orientation }) =>
          orientation === "left" ? <ChevronLeft className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />,
      }}
      classNames={{
        months: "flex flex-col gap-4",
        month: "space-y-2",
        month_caption: "flex h-8 items-center justify-center",
        caption_label: "text-sm font-medium",
        nav: "absolute flex w-[calc(100%-1.5rem)] items-center justify-between",
        button_previous: "flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:bg-muted",
        button_next: "flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:bg-muted",
        month_grid: "w-full border-collapse",
        weekdays: "flex",
        weekday: "w-9 text-center text-xs font-normal text-muted-foreground",
        week: "mt-1 flex",
        day: "p-0 text-center",
        day_button: "h-9 w-9 rounded-md text-sm hover:bg-muted aria-selected:opacity-100",
        selected: "bg-primary/15",
        range_start: "rounded-l-md bg-primary text-primary-foreground [&>button]:hover:bg-primary",
        range_end: "rounded-r-md bg-primary text-primary-foreground [&>button]:hover:bg-primary",
        range_middle: "bg-primary/15",
        today: "font-semibold text-primary",
        outside: "text-muted-foreground/40",
        disabled: "text-muted-foreground/30",
        hidden: "invisible",
      }}
      {...props}
    />
  );
}
